export default {
  onboarding: {
    actions: {
      mainBlue: 'Beginnen'
    }
  },
  details: {
    stepTitle: 'Informationen zum Schadensfall',
    title: 'Details des beschädigten Gutes: ',
    aboutProperty: 'Bitte bestätigen Sie uns die folgenden Informationen:',
    errorMsgInputTxt: 'Pflichtfelder',
    errorMsgGeneral: 'Überprüfen Sie das Formular, bevor Sie fortfahren',
    errorImages: 'Bitte fügen Sie Fotos hinzu, bevor Sie fortfahren.',
    warningMsg: 'Sollten diese Informationen unvollständig oder falsch sein, bitten wir Sie, sich mit Ihrem üblichen Allianz Ansprechpartner in Verbindung zu setzen.',
    address: {
      literal: 'Adresse',
      placeholder: 'Geben Sie einen Ort ein'
    },
    zipCode: {
      literal: 'Postleitzahl'
    },
    propertyType: {
      literal: 'Art der Immobilie',
      options: {
        appartment: 'Wohnung',
        maison: 'Haus',
        local_commercial: 'Geschäftslokal'
      }
    },
    residentType: {
      literal: 'Art des Bewohners',
      options: {
        propietarie: 'Eigentümer',
        locataire: 'Mieter',
        propietarie_non_occupant: 'Eigentümer Nicht bewohnend'
      }
    },
    moreThanTwoYears: {
      literal: 'Alter des Gebäudes',
      options: {
        less: 'Weniger als 2 Jahre',
        more: 'Mehr als 2 Jahre'
      }
    },
    observations: {
      literal: 'Bemerkungen'
    },
    map: {
      empty: {
        title: 'Ohne Adresse',
        text: 'Bitte geben Sie eine gültige Adresse ein.'
      }
    },
    textArea: {
      placeHolder: 'Die Textlänge ist auf maximal 255 Zeichen begrenzt'
    }
  },
  closing: {
    actions: {
      mobilierButton: 'Fahren Sie mit Möbelschäden fort'
    }
  },
  compensationType: {
    title: 'Welche Lösung bevorzugen Sie für Ihre Immobilienschäden?',
    subtitle: '�ber Ihren Sachschaden ',
    propertyDamage: ' Gemeldete Immobilienschäden',
    text: 'Dazu bieten wir drei mögliche Lösungen an:',
    recommended: 'Notre recommandation!',
    amount: 'Unsere Empfehlung!',
    e2eCompensations: {
      ourRecommendation: 'Unsere Empfehlung',
      gagDetail: {
        title: 'Meine Arbeiten selbst durchführen',
        text: 'Wenn Sie sich für diese Lösung entscheiden, erhalten Sie die unten aufgeführte Sofortentschädigung, die es Ihnen ermöglicht, die Arbeiten zur Wiederherstellung Ihres Eigentums in identischer Form selbstständig durchzuführen.',
        link: 'Diese Lösung wählen'
      },
      billma: {
        title: 'Meinen eigenen Handwerker wählen',
        text: 'Fügen Sie den Kostenvoranschlag des Handwerkers Ihrer Wahl bei, um Ihre Entschädigung zu erhalten.',
        link: 'Diese Lösung wählen'
      },
      renDetail: {
        title: 'Wählen Sie einen Handwerker mit Allianz-Zulassung',
        text: 'Geben Sie uns Ihre Verfügbarkeit an, damit ein zugelassener Allianz Partner Ihren Schaden reparieren kann. Sie profitieren von qualitativ hochwertigen Reparaturen ohne bürokratischen Aufwand. Lediglich die Selbstbeteiligung müssen Sie selbst tragen.',
        link: 'Diese Lösung wählen'
      }
    }
  },
  compensationMobilier: {
    title: 'Zu Ihrem Sachschaden',
    subtitle: 'Höhe der Entschädigung',
    total: 'Gesamt:',
    totalAmount: 'Gesamtvergütung',
    actions: {
      primary: 'Ja, ich akzeptiere die vorgeschlagene Entschädigung',
      secondary: 'Ich möchte mit einem Berater sprechen'
    }
  }
}
